import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { defaultNavigation, horizontalNavigation } from 'app/mock-api/common/navigation/data';
import { NavigationPermissionHelper } from 'app/core/navigation/navigation-permission.helper';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class NavigationMockApi {
    // private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation; // Commented out - Fuse template demo
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    // private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation; // Commented out - Fuse template demo
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        console.log('[MockApi] NavigationMockApi instanciado');
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {
                console.log('[MockApi] GET /api/common/navigation llamado');
                // Fill compact navigation children using the default navigation
                // COMMENTED OUT - Fuse template demo navigation
                /*
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === compactNavItem.id) {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === futuristicNavItem.id) {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });
                */

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if (defaultNavItem.id === horizontalNavItem.id) {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Clone navigation for response
                const clonedDefaultNav = cloneDeep(this._defaultNavigation);
                const clonedHorizontalNav = cloneDeep(this._horizontalNavigation);

                // Apply dynamic navigation modifications based on user permissions
                this._applyDynamicNavigationChanges(clonedDefaultNav);
                this._applyDynamicNavigationChanges(clonedHorizontalNav);

                // Return the response
                return [
                    200,
                    {
                        // compact: cloneDeep(this._compactNavigation), // Commented out - Fuse template demo
                        default: clonedDefaultNav,
                        // futuristic: cloneDeep(this._futuristicNavigation), // Commented out - Fuse template demo
                        horizontal: clonedHorizontalNav,
                    },
                ];
            });
    }

    /**
     * Apply dynamic navigation changes based on user role and permissions
     * Modifies navigation items in-place
     */
    private _applyDynamicNavigationChanges(navigation: FuseNavigationItem[]): void {
        navigation.forEach(group => {
            if (group.children) {
                group.children.forEach(item => {
                    // Update project menu title and badge based on user role
                    if (item.id === 'honeytokens.projects') {
                        // Set dynamic title: "Todos los Proyectos" for Admin, "Mis Proyectos" for others
                        item.title = NavigationPermissionHelper.getProjectMenuTitle();
                        
                        // Add ownership badge for Project Managers
                        const badge = NavigationPermissionHelper.getProjectOwnershipBadge();
                        if (badge) {
                            item.badge = badge;
                        }
                    }
                    
                    // Recursively apply changes to nested items
                    if (item.children) {
                        this._applyDynamicNavigationChanges([item]);
                    }
                });
            }
        });
    }
}
